var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.966.546a1.18 1.18 0 0 0-1.671 0L8.5 6.329 2.705.534a1.18 1.18 0 0 0-1.67 0 1.18 1.18 0 0 0 0 1.671L6.828 8l-5.795 5.795a1.18 1.18 0 0 0 0 1.67 1.18 1.18 0 0 0 1.671 0L8.5 9.672l5.795 5.795a1.18 1.18 0 1 0 1.67-1.671L10.172 8l5.795-5.795c.45-.45.45-1.209 0-1.659Z",
  fill: "#1A1A1A"
})));
export default SvgClose;